<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserName }}</p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class=" con-img ml-3 settings-button hover-class">
        <img
          src="@/assets/images/pages/settings.svg"
          alt="Smiley face"
          height="42"
          width="42"
          @mouseover="hover = true"
          @mouseout="hover = false"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <!--          <li-->
          <!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
          <!--          >-->
          <!--            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />-->
          <!--            <span class="ml-2">Profile</span>-->
          <!--          </li>-->

          <!--          <li-->
          <!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
          <!--          >-->
          <!--            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />-->
          <!--            <span class="ml-2">Inbox</span>-->
          <!--          </li>-->

          <!--          <li-->
          <!--            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"-->
          <!--          >-->
          <!--            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />-->
          <!--            <span class="ml-2">Tasks</span>-->
          <!--          </li>-->

          <!--          <vs-divider class="m-1" />-->

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hover: false
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    activeUserName() {
      return this.activeUserInfo.name ? this.activeUserInfo.name : "Account";
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutUser");
    }
  }
};
</script>
<style scoped>
.settings-button {
  border-radius: 50%;
  transition: 0.3s;
  max-height: 42px;
}
</style>
